import { render, staticRenderFns } from "./PartsMine.vue?vue&type=template&id=92838c38&"
import script from "./PartsMine.vue?vue&type=script&lang=ts&"
export * from "./PartsMine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports